import BaseComponent from '../../components/BaseComponent';
import Manipulator from '../../utils/dom/manipulator';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'ClubSinkingInput';

class ClubSinkingInput extends BaseComponent {

	constructor(element) {
		super(element);
		this.inputElement = SelectorEngine.findOne('input', this._element);
		this.hasError = false;
		EventHandler.on(this.inputElement, 'change', (event) => {
			const number_ = +event.target.value;
			if(number_ >= 0 && number_ <= 99 && number_ % 1 === 0) {
				this.hideError();
			} else {
				this.showError();
			}
		});
	}

	getName() {
		const { fieldName } = Manipulator.getDataAttributes(this._element);
		return fieldName;
	}

	getCount() {
		let count = +this.inputElement.value;
		if(Number.isNaN(+count)) {
			count = 0;
		}
		return count;
	}

	getValue() {
		let { fund } = Manipulator.getDataAttributes(this._element);
		if(Number.isNaN(+fund)) {
			fund = 0;
		}
		return fund;
	}

	getTotal() {
		const count = this.getCount();
		return this.getValue() * count;
	}

	getData() {
		return {
			count: +this.getCount(),
			value: +this.getValue(),
			name: this.getName(),
			total: +this.getTotal(),
			hasError: this.hasError
		};
	}

	showError() {
		const ErrorElement = SelectorEngine.findOne('.js-club-sinking-input-error', this._element);
		ErrorElement.classList.remove('u-hidden');
		this.hasError = true;
	}

	hideError() {
		const ErrorElement = SelectorEngine.findOne('.js-club-sinking-input-error', this._element);
		ErrorElement.classList.add('u-hidden');
		this.hasError = false;
	}

	static get NAME() {
		return NAME;
	}
}

export default ClubSinkingInput;
